(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    function updateFacetsToggleStickyOffset() {
    var headerSection = document.querySelector('.header-section');
    var offset = headerSection ? headerSection.offsetHeight : 0;
    document.documentElement.style.setProperty('--facets-toggle-sticky-offset', offset + 'px');
  }

  if (window.ResizeObserver) {
    var headerSectionEl = document.querySelector('.header-section');
    if (headerSectionEl) {
      new ResizeObserver(updateFacetsToggleStickyOffset).observe(headerSectionEl);
    }
  }

  window.addEventListener('resize', updateFacetsToggleStickyOffset);
  updateFacetsToggleStickyOffset();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hero-sidebar-tab"] && !Shopify.designMode) return;
  try {
    function alignHeroSidebarTabs() {
    document.querySelectorAll('[data-hero-sidebar-tab]').forEach(function (tab) {
      var heroContainer = tab.closest('.hero__container');
      var mediaGrid = heroContainer ? heroContainer.querySelector('.hero__media-grid') : null;
      if (!heroContainer || !mediaGrid) return;

      // Measure the actual rendered gap between the (page-width-constrained)
      // content wrapper this tab lives in and the true left edge of the
      // full-bleed hero image, then compensate exactly — more reliable than
      // trying to derive it from the grid's own calc()/min() formulas, which
      // don't resolve the same way at every viewport/content-width combo.
      var wrapperLeft = tab.parentElement.getBoundingClientRect().left;
      var mediaLeft = mediaGrid.getBoundingClientRect().left;
      tab.style.setProperty('--hero-sidebar-tab-offset', (mediaLeft - wrapperLeft) + 'px');
    });
  }

  window.addEventListener('resize', alignHeroSidebarTabs);
  document.addEventListener('DOMContentLoaded', alignHeroSidebarTabs);
  alignHeroSidebarTabs();
  } catch(e) { console.error(e); }
})();

})();
